export default __webpack_public_path__ + "static/media/demo2.149d93ec.png";